export default __webpack_public_path__ + "assets/1f105054c7a5b0e9f330c20599b4a776.jpg";